import { businessInfo, navLinks, services } from "@/mocks/home";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="mb-5">
              <img
                src={businessInfo.logoWhite}
                alt="Laboratorio Clínico ANEDAN"
                title="Laboratorio Clínico ANEDAN"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-background-300 leading-relaxed max-w-xs">
              Análisis clínicos y ultrasonido con calidad, precios accesibles y un trato humano que te hace
              sentir en confianza. Un espacio seguro e inclusivo en Tlalnepantla.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5">Navegación</h4>
            <ul className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5">Servicios</h4>
            <ul className="flex flex-col gap-3">
              {services.map((service) => (
                <li key={service.title}>
                  <a
                    href="#servicios"
                    className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {service.title}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#contacto"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  Ubicación y horarios
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5">Contacto</h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-fill text-primary-300 text-lg mt-0.5"></i>
                <a
                  href={businessInfo.phoneLink}
                  className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  {businessInfo.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-2-fill text-primary-300 text-lg mt-0.5"></i>
                <span className="text-sm text-background-200 leading-relaxed">{businessInfo.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-fill text-primary-300 text-lg mt-0.5"></i>
                <span className="text-sm text-background-200">{businessInfo.hoursFull}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400 text-center sm:text-left">
            © {year} Laboratorio Clínico ANEDAN. Todos los derechos reservados.
          </p>
          <p className="text-xs text-background-400 flex items-center gap-2">
            <i className="ri-rainbow-line text-accent-300"></i>
            Espacio seguro y amigable con la comunidad LGBTQ+
          </p>
        </div>
      </div>
    </footer>
  );
}